import { render, staticRenderFns } from "./lavora.vue?vue&type=template&id=4ce0a77d&scoped=true"
import script from "./lavora.vue?vue&type=script&lang=js"
export * from "./lavora.vue?vue&type=script&lang=js"
import style0 from "./lavora.vue?vue&type=style&index=0&id=4ce0a77d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce0a77d",
  null
  
)

export default component.exports